<template>
    <div style="position:relative;font-size:12px">
        <compWrapper :title="$t('erp.product.project_detail', { defaultValue: '项目详情' })" theme="primary">
            <compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getBase" :value="formData" :labelWidth="120"></compFormQuery>
            <compFormEdit v-else class="margin-top-15 margin-right-15" ref="baseform" :formdata="getBase" v-model="formData" :labelWidth="120"></compFormEdit>
        </compWrapper>
        <compWrapper :title="$t('global.common.operation_history', { defaultValue: '操作历史' })" theme="gray" v-if="type=='query'">
            <compLog :data="logList"></compLog>
        </compWrapper>

        <div class="text-right padding-right-20" v-show="type!='query'">
            <vButton theme="primary" @click="submit">{{$t('global.modal.confirm', { defaultValue: '确定' })}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</vButton>
        </div>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>

    import { mapState, mapGetters, mapMutations} from "vuex";
    import compClear from '../compclear';
    import {
        HttpSysOpLog
    } from '@/service/boss/allot';
    import {
        HttpGetProductsLine,
        HttpEditLine,
    } from '@/service/products/productline';

    export default {
        props:['activeids','querytype'],
    data(){
        return {
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            formData: {
                orgId:global.SYSID,
                name:'',
                projectUnicode:'',
                nickname:'',
                manager:'',
                description:'',
            },
            showquery :null,
            logList:[],
            cleardata:{},
        }
    },
    created(){
        if(this.activeids){
            this.id = this.activeids
            this.type = this.querytype
        }else{
            this.id = this.id
            this.type = this.type
        }
        this.showquery = this.type == 'query' || this.type == 'edit'
        this.getDetail()
    },

    computed:{
        ...mapState('boss', ['products']),
        ...mapGetters('diction',['getAllProductPerson']),
        getUserList(){
            return this.getAllProductPerson.filter(function(item){
                // console.log(item)
                return item.label != ''
            })
        },
        getBase() {
            return [{
                    label: this.$t('erp.product.project_name', { defaultValue: '项目名称' }) + "：",
                    key: "name",
                    tag: "vInput",
                },
                {
                    label: this.$t('erp.product.project_sample_name', { defaultValue: '项目简称' }) + "：",
                    key: "projectUnicode",
                    tag: "vInput",
                    maxlength: 5,
                    formItem:{
                        tip: this.type=='query'?'':`<div class="color-error">${this.$t('erp.product.input_tip_1', { defaultValue: '（可使用字母、数字、下划线、横杠,不含空格,不超过5位字符）' })}</div>`,
                    }
                },
                {
                    label: this.$t('erp.product.project_other_name', { defaultValue: "项目别名：" }),
                    key: "nickname",
                    tag: "vInput",
                    required:false,
                },
                {
                    label: this.$t('erp.product.project_incharge', { defaultValue: "项目负责人" }),
                    tag: 'vSelect',
                    key: 'manager',
                    required:false,
                    options:this.getUserList,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: this.$t('fbb.accountmanage.description', { defaultValue: '描述' }) + "：",
                    tag: "vInput",
                    key: "description",
                    required:false,
                },
            ];
        },
    },
    methods:{
         ...mapMutations('diction', ['clearStore']),
        getDetail(){
            if(this.type=='add') return
            if(this.type=='query'){
                // 请求操作历史
                HttpSysOpLog({
                    search: {
                        EQ_opDataId: this.id,
                        EQ_opModel: 'ProductLine'
                    }
                }).then(res => {
                    this.logList = res.data.content
            }, err => {

                })
            }
            this.loading=true;
            HttpGetProductsLine({
                id:this.id
            }).then(res=>{
                this.loading=false;
                this.formData = res.data;
            },err=>{
                this.loading=false;
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },

        async submit() {
            // 验证基本信息
			const valid1 = await this.$refs['baseform'].validate();
            if (!valid1) return;

            this.formData.id = this.id;

            // let linestr = projectUnicode
            var titleLine = /^([A-Za-z0-9-_./#]{1,5})$/;
			if(titleLine.test(this.formData.projectUnicode)===false && this.type != 'query'){
				this.$VMessage.error(this.$t('erp.product.input_tip_project_name', { defaultValue: '项目简称输入不符合规范' }));
				return
			}
            this.loading = true;
            HttpEditLine(this.formData).then(res => {
                this.clearStore('newProductList');
                this.cancel();
                this.$emit('on-update');
                this.$VMessage.success(res.message);
                this.loading = false;
            }).catch(err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                this.loading = false;
            });
        },

        cancel(){
            if(this.querytype == 'edit'){
                this.$emit('on-close')
            }else{
                this.$router.push({
                    name: "productLineList"
                })
            }
        }
    }
    }
</script>
